import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from '../core/Modal'
import Button from '../elements/Button'
import Radio from '../elements/Radio'
import { NEW_CUSTOMER_EXPERIENCE } from '../../constants/content'

const AddressMismatchModal = ({
  visible,
  onCancel,
  addressMismatchOptions,
  getOrderServices,
  fxbuyflowSessionId
}) => {
  const [selectedId, setSelectedId] = useState(null)

  const handleProceed = () => {
    const selected = addressMismatchOptions.find(r => r.id === selectedId)
    if (selected && selected.text.includes(NEW_CUSTOMER_EXPERIENCE)) {
      onCancel()
    } else {
      getOrderServices({
        fxbuyflowSessionId,
        isEcConversion: true,
        onComplete: onCancel
      })
    }
  }

  return (
    <StyledModal
      title="Existing Account Found"
      visible={visible}
      allowClose={false}
      footer={false}
      maskClosable={false}
      width={600}
      keyboard={false}
    >
      {addressMismatchOptions && addressMismatchOptions.length > 0 ? (
        <>
          <RadioGroup>
            {addressMismatchOptions.map(option => (
              <Radio
                key={option.id}
                id={`address-mismatch-${option.id}`}
                name="address-mismatch"
                checked={selectedId === option.id}
                onChange={() => setSelectedId(option.id)}
                ariaLabel={option.text}
              >
                {option.text}
              </Radio>
            ))}
          </RadioGroup>
          <strong>One selection is required to continue.</strong>
          <Footer>
            <StyledButton
              type="primary"
              disabled={selectedId === null}
              onClick={handleProceed}
            >
              Proceed
            </StyledButton>
          </Footer>
        </>
      ) : (
        <div>No address mismatch options available.</div>
      )}
    </StyledModal>
  )
}

AddressMismatchModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  addressMismatchOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string
    })
  ),
  getOrderServices: PropTypes.func,
  fxbuyflowSessionId: PropTypes.string
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 5px 10px;
  }
  .ant-modal-header {
    text-align: center;
  }
  .ant-modal-title {
    font-size: 1.2rem;
  }
`
const RadioGroup = styled.div`
  margin: 0 0 20px 0;
`
const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`
const StyledButton = styled(Button)`
  margin-left: 10px;
`

export default AddressMismatchModal